// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"983c7d00","412":"4cd39c2b","416":"4ee1d5aa","488":"29888ccd","512":"8430b5fa","538":"f9c6b042","548":"6859c1a0","676":"c66ebb54","728":"34ca4d9b"}[chunkId] + ".chunk.js";
};